<!--
 * @Author: Antigravity
 * @Date: 2026-03-24
 * @Description: 投诉件分析
-->

<template>
  <div class="w-full flex flex-col px-16 pb-49">
    <!-- 投诉件概况 -->
    <ComplaintOverviewCell ref="overviewCellRef" />

    <!-- 投诉件分类 -->
    <ComplaintClassifyCell class="mt-4" />

    <!-- 投诉件发起量走势 -->
    <ComplaintTrendCell class="mt-4" />
  </div>
</template>

<script>
import ComplaintOverviewCell from './comps/ComplaintOverviewCell.vue';
import ComplaintClassifyCell from './comps/ComplaintClassifyCell.vue';
import ComplaintTrendCell from './comps/ComplaintTrendCell.vue';

export default {
  name: "ComplainAnalysis",
  components: {
    ComplaintOverviewCell,
    ComplaintTrendCell,
    ComplaintClassifyCell
  },
  data() {
    return {
    }
  },
  computed: {
    deptInfo() {
      return this.$store.state.complaint.deptInfo;
    }
  },
  mounted() {
    // 各个 Cell 已通过 visualFilterMixin 实现自动按需加载
  }
};
</script>

<style lang="less" scoped>
.wrap {
  margin: 0 12px 12px;
  margin-bottom: 49px;
}
</style>
